const applyCurrencySchema = (schema, message = "Please enter a valid price", min = 0.01, isNullable = false) =>
    schema
        .typeError(message)
        .min(min, message)
        .test(
            "maxDigitsAfterDecimal",
            "Please enter a valid price",
            (number) => {
                if ((number === undefined || number === null) && isNullable) return true;
                return /^\d+(\.\d{1,2})?$/.test(number);
            }
        );

export default applyCurrencySchema;
